import axios from "axios";
import { apiURL } from './api.js';

// Function to get all kids for a user
export const getKids = async (userId) => {
    try {
        const token = localStorage.getItem('authToken');
        
        if (!userId) {
            throw new Error('User ID is required');
        }

        if (!token) {
            throw new Error('Authentication token is required');
        }
        
        const response = await axios.get(`${apiURL}/kids/${userId}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        
        if (response.status !== 200) {
            throw new Error('Failed to fetch kids');
        }
        
        return response.data;
    } catch (error) {
        console.error('Error fetching kids:', error);
        throw error;
    }
};

// Function to set default kid
export const setDefaultKid = async (kidId, userId) => {
    try {
        const token = localStorage.getItem('authToken');
        
        if (!kidId) {
            throw new Error('Kid ID is required');
        }

        if (!token) {
            throw new Error('Authentication token is required');
        }
        
        const response = await axios.post(`${apiURL}/kids/set-default`, 
            { kid_id: kidId },
            {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            }
        );
        
        if (response.status !== 200) {
            throw new Error('Failed to set default kid');
        }
        
        return response.data;
    } catch (error) {
        console.error('Error setting default kid:', error);
        throw error;
    }
};

// Function to get kid's coin balance
export const getKidCoins = async (kidId) => {
    try {
        const token = localStorage.getItem('authToken');
        
        if (!kidId) {
            throw new Error('Kid ID is required');
        }

        if (!token) {
            throw new Error('Authentication token is required');
        }
        
        const response = await axios.get(`${apiURL}/kids/${kidId}/coins`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        
        if (response.status !== 200) {
            throw new Error('Failed to fetch kid coins');
        }
        
        return response.data;
    } catch (error) {
        console.error('Error fetching kid coins:', error);
        throw error;
    }
};

// Function to get kid's full details (aggregator)
export const getKidFullDetails = async (kidId) => {
    try {
        const token = localStorage.getItem('authToken');
        
        if (!kidId) {
            throw new Error('Kid ID is required');
        }

        if (!token) {
            throw new Error('Authentication token is required');
        }

        const headers = {
            'Authorization': `Bearer ${token}`,
            'Accept': 'application/json'
        };

        // Parallel fetching with refined fallbacks
        const [coinsResponse, progressResponse] = await Promise.all([
        axios.get(`${apiURL}/kids/${kidId}/coins`, { headers })
            .catch(err => {
            console.error("Coins API Fail:", err.message);
            return { data: { coin_balance: 0 } }; // Fallback object
            }),
        axios.get(`${apiURL}/kids/${kidId}/finished-levels`, { headers })
            .catch(err => {
            console.error("Progress API Fail:", err.message);
            return { data: [] }; // Fallback array
            })
        ]);

        // MAP DATA: Laravel often wraps responses in a 'data' property
        const coinData = coinsResponse.data.data || coinsResponse.data;
        const progressData = progressResponse.data.data || progressResponse.data;

        if (coinsResponse.status !== 200 || progressResponse.status !== 200) {
            throw new Error('Failed to fetch kid details');
        }

        return {
            kid_id: parseInt(kidId),
            coin_balance: coinData.coin.coin_balance || 0,
            progress: Array.isArray(progressData.finished_levels) ? progressData.finished_levels : []
        };
        
    } catch (error) {
        console.error('Error fetching kid full details:', error);
        throw error;
    }
};
